import { createContext, useContext, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCaseStudies, deleteCaseStudy } from "../../api/case-studies";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [term, setTerm] = useState("");

  const getCaseStudiesQuery = useQuery({
    queryKey: ["case-studies", term],
    queryFn: () => getCaseStudies(term),
  });

  const deleteCaseStudyMutation = useMutation({ mutationFn: deleteCaseStudy });

  const handleDeleteClick = (item) => {
    deleteCaseStudyMutation.mutate(item._id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["case-studies"]);
        toaster.success(Const.MESSAGES.SUCCESS, "Case Study deleted successfully.");
      },
      onError: (err) => {
        toaster.error(Const.MESSAGES.FAILED, err?.response?.data?.error || "Failed to delete case study");
      }
    });
  };

  const handleAddClick = () => {
    navigate("/add-case-study");
  };

  const handleEditClick = (item) => {
    navigate(`/add-case-study?id=${item.slug_url}`);
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    setTerm(value);
  };

  return (
    <PageContext.Provider
      value={{
        getCaseStudiesQuery,
        handleDeleteClick,
        handleAddClick,
        handleEditClick,
        handleOnChange,
      }}>
      {children}
    </PageContext.Provider>
  );
};

export const useCaseStudiesProvider = () => {
  return useContext(PageContext);
};
